import * as React from 'react';
import styled from 'styled-components';
import { IComparisonPopulationSetting } from '../../../data/providers/settings/comparisonPopulationSettingsProvider';
import {
  IExclusiveDateOption,
  IInclusiveDateOption,
} from '../../../data/providers/settings/dates/dateRangeProvider';
import { EZScorePreference, IRange, ISelectOption } from '../../../data/types';
import { Row } from '../../layout/Row';
import { ControlLabel } from '../../shared/form/ControlLabel';
import { ControlSpacer } from '../../shared/form/ControlSpacer';
import { SelectBox } from '../../shared/form/SelectBox';
import { DateSelect } from '../../shared/form/selects/DateRangeSelect';
import { PopulationSelect } from '../../shared/form/selects/PopulationSelect';

interface IProps {
  handleEntityChange: (opt: ISelectOption<string>) => void;
  handleDateChange: (
    type: IExclusiveDateOption | IInclusiveDateOption,
    range: IRange
  ) => void;
  handleZScorePreferenceChange?: (pref: EZScorePreference) => void;
  settings: IComparisonPopulationSetting;
  zscoreDisabled?: boolean;
  inclusiveDates?: boolean;
}

export const ComparisonSettings = (props: IProps): React.ReactElement => {
  const selectLabels = {
    scaled: 'Scaled (0 - 100)',
    unscaled: 'Unscaled (-4 - 4)',
  };
  const handlePreferenceChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const { checked, name } = e.currentTarget;
    if (checked && name === selectLabels.scaled) {
      props.handleZScorePreferenceChange(EZScorePreference.Scaled);
    } else {
      props.handleZScorePreferenceChange(EZScorePreference.Unscaled);
    }
  };
  return (
    <React.Fragment>
      <ControlSpacer style={{ padding: '10px' }}>
        <ControlLabel>Comparison Population</ControlLabel>
        <PopulationSelect
          onChange={props.handleEntityChange}
          value={props.settings?.entity}
        />
      </ControlSpacer>
      <ControlSpacer style={{ padding: '10px' }}>
        <DateSelect
          type={props?.inclusiveDates ? 'inclusive' : 'exclusive'}
          dateRangeType={props.settings?.dateRangeType}
          dateRange={props.settings?.dateRangeValues}
          onChange={props.handleDateChange}
        />
      </ControlSpacer>
      {!props.zscoreDisabled && (
        <ControlSpacer style={{ padding: '10px' }}>
          <ControlLabel>ZScores</ControlLabel>
          <Row>
            <SelectBoxContainer>
              <SelectBox
                onSelect={handlePreferenceChange}
                selected={
                  props.settings?.zScorePreference === EZScorePreference.Scaled
                }
                label={selectLabels.scaled}
              />
            </SelectBoxContainer>
            <SelectBoxContainer>
              <SelectBox
                onSelect={handlePreferenceChange}
                selected={
                  props.settings?.zScorePreference ===
                  EZScorePreference.Unscaled
                }
                label={selectLabels.unscaled}
              />
            </SelectBoxContainer>
          </Row>
        </ControlSpacer>
      )}
    </React.Fragment>
  );
};

const SelectBoxContainer = styled.div`
  &:last-child {
    margin-left: 10px;
  }
`;
